<template>
  <div class="generalWindow">
    <div :class="showWindow == true ? 'on' : ''" class="generalTip">
      <div class="pictrue">
        <!-- <img src="../assets/images/promoter.png" /> -->
        <div style="font-weight: 700;font-size: 20px;">
          会员好礼
        </div>

        <div style="font-size: 12px;">
          尊敬的会员，感谢您对追风者的支持与厚爱！作为回馈，我们为您准备了专属优惠和惊喜活动，期待您的参与！
        </div>
      </div>

      <div ref="container">
        <div class="coupon-list"  v-if="couponsList.length > 0">
          <div class="item acea-row row-center-wrapper" 
          style="flex-wrap: nowrap;transform: scale(.8);"
          v-cloak v-for="(item, index) in couponsList" :key="index">
            <div class="money" :class="item._type === 0 ? 'moneyGray' : ''">
              <div>
                ￥<span class="num">{{ item.coupon_price }}</span>
              </div>
              <div class="pic-num">满{{ item.use_min_price }}元可用</div>
            </div>
            <div class="text">
              <div class="condition line1">
                <span class="line-title" :class="item._type === 0 ? 'bg-color-huic' : 'bg-color-check'"
                  v-if="item.applicable_type === 0">通用劵</span>
                <span class="line-title" :class="item._type === 0 ? 'bg-color-huic' : 'bg-color-check'"
                  v-else-if="item.applicable_type === 1">品类券</span>
                <span class="line-title" :class="item._type === 0 ? 'bg-color-huic' : 'bg-color-check'"
                  v-else>商品券</span>
                <span>{{ item.coupon_title }}</span>
              </div>
              <div class="data acea-row row-between-wrapper">
                <div v-if="item._end_time === 0">不限时</div>
                <div v-else>{{ item._add_time }}-{{ item._end_time }}</div>
                <div class="bnt gray" v-if="item._type === 0">{{ item._msg }}</div>
                <div class="bnt bg-color-red" v-else>{{ item._msg }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--暂无优惠券-->
        <div class="noCommodity" v-if="couponsList.length === 0 && loading === true">
          <div class="noPictrue">
            <img src="@assets/images/noCoupon.png" class="image" />
          </div>
        </div>
      </div>


      <!-- <div class="name" v-text="generalContent.title"></div>
      <div class="info" v-html="generalContent.promoterNum"></div> -->
      <div>
        <!-- <div class="tipBnt tipBnt_color" @click="close">立即领取</div> -->
        <div class="tipBnt">
          <router-link :to="'/user/user_form'" class="tipBnt">
            <div>去申请</div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent v-show="showWindow" @click="close"></div>
  </div>
</template>

<script>
export default {
  name: "GeneralWindow",
  props: {
    showWindow: {
      type: Boolean,
      default: false
    },
    couponsList: {
      type: Array,
      default: []
    },

  },
  data() {
    return {


    };
  },



  methods: {

    close: function () {
      this.$emit("closeMemberWindow", false);
    }






  }
};
</script>

<style scoped>
.generalWindow .generalTip {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 5.6rem;
  margin-left: -2.8rem;
  z-index: 666;
  border-radius: 0.2rem;
  background-color: #fff;
  transition: all 0.3s ease-in-out 0s;
  opacity: 0;
  transform: scale(0);
  padding-bottom: 0.6rem;
  margin-top: -3.3rem;
}

.generalWindow .generalTip.on {
  opacity: 1;
  transform: scale(1);
}

.generalWindow .generalTip .pictrue {
  width: 100%;
  /* height: 2.7rem; */
  padding: 0.3rem;
  padding-bottom: 0;
}

.generalWindow .generalTip .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem 0.2rem 0 0;
}

.generalWindow .generalTip .name {
  font-size: 0.36rem;
  font-weight: bold;
  color: #282828;
  text-align: center;
  padding: 0 0.29rem;
  margin-top: 0.37rem;
}

.generalWindow .generalTip .info {
  font-size: 0.3rem;
  color: #666;
  padding: 0 0.29rem;
  text-align: center;
  margin-top: 0.21rem;
}

.generalWindow .generalTip .info .money {
  font-weight: bold;
  margin: 0 0.1rem;
}

.generalWindow .generalTip .help {
  font-size: 0.32rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.4rem;
}

.generalWindow .generalTip .tipBnt {
  font-size: 0.32rem;
  color: #fff;
  width: 3.6rem;
  height: 0.82rem;
  border-radius: 0.41rem;
  background-image: linear-gradient(to right, #80cdd4, #80cdd4);
  text-align: center;
  line-height: 0.82rem;
  margin: 0.5rem auto 0 auto;
}

.generalWindow .generalTip .tipBnt_color {
  color: #80cdd4;
  border: 1px solid #80cdd4;
  background: none;
}
</style>
